export default "__VITE_ASSET__CbPyafMH__"